<template>
  <div class="row">
    <div class="col-xl-12">
      <div class="kt-portlet kt-portlet--mobile">
        <div class="kt-portlet__head">
          <div class="kt-portlet__head-label">
            <h3 class="kt-portlet__head-title">ตรวจสอบใบงานที่ต้องอนุมัติ</h3>
          </div>
          <div class="kt-portlet__head-toolbar">
            <router-link to="/BudgetPlan/Job" class="btn btn-secondary btn-sm">
              <i class="la la-arrow-left"></i> กลับ
            </router-link>
          </div>
        </div>
        <div class="kt-portlet__body">
          <div class="alert mb-3" style="background-color: #FFFBE6; border: 1px solid #FFE58F; color: #856404; margin-left: 0; padding: 0.375rem 0.75rem; display: flex; align-items: center; min-height: 42px; font-size: 1rem; line-height: 1.5;">
            <i class="fas fa-exclamation-triangle" style="color: #856404; margin-right: 6px;"></i>
            <span>*สถานะดำเนินการจะเป็นสถานะส่งกลับแก้ไขได้ต่อเมื่อใบงานเป็นสถานะรออนุมัติลำดับ 1, รออนุมัติลำดับ 2 เท่านั้น รออนุมัติลำดับอื่นๆสถานะจะเป็นไม่อนุมัติ</span>
          </div>

          <!-- Action Buttons (#91: ตัด (จำนวน) ออก, #93: disable when processing) -->
          <div class="mb-3">
            <button class="btn btn-success mr-2" @click="bulkApprove" :disabled="selectedJobs.length === 0 || isProcessing">
              <i v-if="isProcessing" class="fas fa-spinner fa-spin"></i>
              <i v-else class="fas fa-check"></i>
              อนุมัติ/ยืนยัน รายการที่เลือก
            </button>
            <button class="btn btn-danger" @click="bulkReject" :disabled="selectedJobs.length === 0 || isProcessing">
              <i v-if="isProcessing" class="fas fa-spinner fa-spin"></i>
              <i v-else class="fas fa-times"></i>
              ไม่อนุมัติ/ส่งกลับแก้ไข รายการที่เลือก
            </button>
          </div>

          <!-- Data Table (#86.4: หัวคอลัมจัดกึ่งกลาง+ตัวหนา) -->
          <div class="table-responsive">
            <table class="table table-sm table-striped table-bordered">
              <thead>
                <tr>
                  <th class="text-center" style="width: 3%; font-weight: bold;">ลำดับ</th>
                  <th class="text-center" style="width: 5%; font-weight: bold;">
                    <input type="checkbox" v-model="selectAll" @change="toggleSelectAll" /> เลือกใบงานทั้งหมด
                  </th>
                  <th class="text-center" style="width: 15%; font-weight: bold;">แผนก</th>
                  <th class="text-center" style="width: 25%; font-weight: bold;">รายการสินค้า</th>
                  <th class="text-center" style="width: 10%; font-weight: bold;">จำนวนเงิน</th>
                  <th class="text-center" style="width: 10%; font-weight: bold;">Vendor</th>
                  <th class="text-center" style="width: 12%; font-weight: bold;">หมายเหตุ/เหตุผล</th>
                  <th class="text-center" style="width: 12%; font-weight: bold;">สถานะ</th>
                  <th class="text-center" style="width: 5%; font-weight: bold;">คำสั่ง</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="isLoading">
                  <td colspan="9" class="text-center">
                    <i class="fas fa-spinner fa-spin"></i> กำลังโหลด...
                  </td>
                </tr>
                <tr v-else-if="jobs.length === 0">
                  <td colspan="9" class="text-center text-muted">ไม่มีใบงานที่รออนุมัติ</td>
                </tr>
                <tr v-for="(job, index) in jobs" :key="job.id">
                  <td class="text-center">{{ index + 1 }}</td>
                  <td class="text-center">
                    <input type="checkbox" :value="job.id" v-model="selectedJobs" />
                  </td>
                  <td>[{{ job.orgCode }}] {{ job.orgName }}</td>
                  <!-- #97: ถ้ามี itemNo → "N. desc", ถ้าไม่มี → indent ให้ตรงกับ desc ของ parent -->
                  <td>
                    <div v-for="(item, idx) in job.items" :key="idx">
                      <span v-if="item.itemNo != null">{{ item.itemNo }}. {{ item.description }}</span>
                      <span v-else style="padding-left: 1.5em;">{{ item.description }}</span>
                    </div>
                  </td>
                  <td class="text-right">{{ formatNumber(job.totalAmount) }}</td>
                  <td>{{ job.vendorDisplay }}</td>
                  <td style="vertical-align: middle;">
                    <input type="text" class="form-control form-control-sm"
                      v-model="job.remark" placeholder="หมายเหตุ" />
                  </td>
                  <td class="text-center" style="vertical-align: middle;">
                    <span class="badge"
                      :class="job.approverType === 'CONFIRM' ? 'badge-primary' : 'badge-warning'">
                      {{ job.approverType === 'CONFIRM' ? 'รอยืนยัน' : 'รออนุมัติ ลำดับที่ ' + job.currentApprovalLevel }}
                    </span>
                  </td>
                  <!-- #86.1: ไอคอนแว่นขยาย style เดียวกับ /BudgetPlan/Job (btn-clean btn-icon) + #86.2: new tab + จัดกึ่งกลาง -->
                  <td class="text-center align-middle">
                    <a :href="'/BudgetPlan/Job/View/' + job.id" target="_blank" class="btn btn-sm btn-clean btn-icon btn-icon-md" title="ดูรายละเอียดใบงานงบประมาณ">
                      <i class="fas fa-search"></i>
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      jobs: [],
      selectedJobs: [],
      selectAll: false,
      isLoading: false,
      isProcessing: false, // #93: ป้องกันการกดปุ่มซ้ำ + #94 race condition
    };
  },
  mounted() {
    this.loadPendingJobs();
  },
  methods: {
    loadPendingJobs() {
      var self = this;
      self.isLoading = true;

      axios
        .get("/Api/BudgetPlan/PendingApprovalJobs")
        .then(function (response) {
          self.jobs = response.data || [];
        })
        .catch(function (error) {
          console.error("Failed to load pending jobs:", error);
          Swal.fire("เกิดข้อผิดพลาด", "ไม่สามารถโหลดข้อมูลได้", "error");
        })
        .finally(function () {
          self.isLoading = false;
        });
    },
    toggleSelectAll() {
      if (this.selectAll) {
        this.selectedJobs = this.jobs.map(j => j.id);
      } else {
        this.selectedJobs = [];
      }
    },
    bulkApprove() {
      var self = this;
      if (self.selectedJobs.length === 0 || self.isProcessing) return;  // #93: guard re-entry

      Swal.fire({
        title: "ยืนยันอนุมัติ",
        text: `ต้องการอนุมัติ/ยืนยัน ${self.selectedJobs.length} รายการ?`,
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
      }).then(function (result) {
        if (result.value) {
          // #92: loading overlay + #93: lock button (ใช้รูปแบบเดียวกับหน้า approve job)
          self.isProcessing = true;
          Swal.fire({
            title: "กำลังดำเนินการ...",
            allowOutsideClick: false,
            allowEscapeKey: false,
            onBeforeOpen: () => { Swal.showLoading(); },
          });

          var payload = self.selectedJobs.map(jobId => {
            var job = self.jobs.find(j => j.id === jobId);
            return { jobId: jobId, remark: job ? job.remark : "" };
          });

          axios
            .post("/Api/BudgetPlan/BulkApprove", payload)
            .then(function (response) {
              Swal.fire("สำเร็จ", response.data.message || "อนุมัติเรียบร้อย", "success");
              self.selectedJobs = [];
              self.selectAll = false;
              self.loadPendingJobs();
            })
            .catch(function (error) {
              Swal.fire("เกิดข้อผิดพลาด", (error.response && error.response.data && error.response.data.message) || error.message, "error");
            })
            .finally(function () {
              self.isProcessing = false;
            });
        }
      });
    },
    bulkReject() {
      var self = this;
      if (self.selectedJobs.length === 0 || self.isProcessing) return;  // #93: guard re-entry

      // Validate: ห้ามเลือกรายการ "รอยืนยัน" (CONFIRM) — ใช้ได้เฉพาะปุ่ม "อนุมัติ/ยืนยัน" เท่านั้น
      var confirmJobs = self.selectedJobs.filter(function (jobId) {
        var job = self.jobs.find(function (j) { return j.id === jobId; });
        return job && job.approverType === 'CONFIRM';
      });
      if (confirmJobs.length > 0) {
        Swal.fire("ไม่สามารถดำเนินการได้", "กรุณานำใบงานสถานะ \"รอยืนยัน\" ออกจากตัวเลือก ไม่สามารถดำเนินการใบงานนี้ได้ ต้องใช้รูปแบบ \"อนุมัติ/ยืนยัน รายการที่เลือก\" เท่านั้น", "warning");
        return;
      }

      // Validate: ต้องกรอกหมายเหตุ/เหตุผล ทุกใบที่เลือก
      var missingRemark = self.selectedJobs.filter(function (jobId) {
        var job = self.jobs.find(function (j) { return j.id === jobId; });
        return !job || !job.remark || !job.remark.trim();
      });
      if (missingRemark.length > 0) {
        Swal.fire("ข้อมูลไม่ครบ", "กรุณากรอกหมายเหตุ/เหตุผล ของใบงานที่เลือกทุกใบ", "warning");
        return;
      }

      Swal.fire({
        title: "ยืนยันไม่อนุมัติ/ส่งกลับแก้ไข",
        text: `ต้องการดำเนินการ ${self.selectedJobs.length} รายการ?`,
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
      }).then(function (result) {
        if (result.value) {
          // #92: loading overlay + #93: lock button (ใช้รูปแบบเดียวกับหน้า approve job)
          self.isProcessing = true;
          Swal.fire({
            title: "กำลังดำเนินการ...",
            allowOutsideClick: false,
            allowEscapeKey: false,
            onBeforeOpen: () => { Swal.showLoading(); },
          });

          var payload = self.selectedJobs.map(jobId => {
            var job = self.jobs.find(j => j.id === jobId);
            return { jobId: jobId, remark: job ? job.remark : "" };
          });

          axios
            .post("/Api/BudgetPlan/BulkReject", payload)
            .then(function (response) {
              Swal.fire("สำเร็จ", response.data.message || "ดำเนินการเรียบร้อย", "success");
              self.selectedJobs = [];
              self.selectAll = false;
              self.loadPendingJobs();
            })
            .catch(function (error) {
              Swal.fire("เกิดข้อผิดพลาด", (error.response && error.response.data && error.response.data.message) || error.message, "error");
            })
            .finally(function () {
              self.isProcessing = false;
            });
        }
      });
    },
    formatNumber(num) {
      if (num == null) return "0.00";
      return Number(num).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    },
  },
};
</script>



// WEBPACK FOOTER //
// App/Components/BudgetPlan/BudgetPlanGroupApprove.vue